import { makeAutoObservable } from "mobx";
import { EMAIL_CATEGORY } from "../../../services/api/email-content-service";
import NotificationEventStore from "./notification-event-store";

export class EmailCategoryStore {
    public isExpanded?: boolean;

    constructor(public category: EMAIL_CATEGORY, public list: NotificationEventStore[]) {
        this.isExpanded = false;
        makeAutoObservable(this);
    }
}